import { NgClass } from '@angular/common';
import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  NgFooterTemplateDirective,
  NgOptionComponent,
  NgSelectComponent,
} from '@ng-select/ng-select';

import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { CurveType } from '@shared/services/gql.service';

import {
  ForecastTableGridMethodChange,
  ForecastTableGridNgOnChangesInterface,
  ForecastTableGridSiteCurveInterface,
} from '../../models/forecast-table-grid.model';

@Component({
  imports: [
    NgSelectComponent,
    TooltipDirective,
    NgClass,
    FormsModule,
    NgOptionComponent,
    NgFooterTemplateDirective,
    IconComponent,
  ],
  selector: 'aux-forecast-table-grid-method-site',
  styleUrls: ['./forecast-table-grid-method-site.component.scss'],
  templateUrl: './forecast-table-grid-method-site.component.html',
})
export class ForecastTableGridMethodSiteComponent implements OnChanges {
  @Input() categoryId = '';
  @Input() disabled = false;
  @Input() driverSettingId = '';
  dropdownOpen = false;
  filteredSiteCurves: ForecastTableGridSiteCurveInterface[] = [];
  @ViewChild('gridMethodSite') public input!: NgSelectComponent;
  @Input() isChild = false;
  @Input() isInvalid = false;
  @Input() onMethodChange!: ForecastTableGridMethodChange;
  @Input() placeholder = '';
  @Input() primarySettingsId = '';
  @Input() siteCurves: ForecastTableGridSiteCurveInterface[] = [];
  @Input() tooltip = '';

  ngOnChanges(changes: ForecastTableGridNgOnChangesInterface): void {
    if (changes.categoryId && changes.categoryId.firstChange) {
      this.initSiteMethod();
    }

    // Filter siteCurves based on selected site period
    this.filterSiteCurves();
  }

  filterSiteCurves(): void {
    const currentCurve = this.siteCurves.find((siteCurve) => {
      return siteCurve.value === this.driverSettingId;
    });

    const currentCurveType = currentCurve?.curveType || CurveType.NET;

    this.filteredSiteCurves = this.siteCurves.filter((siteCurve) => {
      return siteCurve.curveType === currentCurveType;
    });
  }

  initSiteMethod(): void {
    if (!this.driverSettingId) {
      const netSites = this.siteCurves.filter((siteCurve) => {
        return siteCurve.curveType === CurveType.NET;
      });

      if (netSites.length >= 1) {
        this.onModelChange(netSites[0].value);
      }
    }
  }

  onDropdownClose() {
    this.dropdownOpen = false;
  }

  onDropdownOpen() {
    this.dropdownOpen = true;
  }

  onModelChange(event: string): void {
    this.onMethodChange(event, this.primarySettingsId, {
      id: this.categoryId,
      name: !this.isChild ? 'category' : 'activity',
      prop: 'driver_setting',
    });
  }
}
